module.exports = function () {
    return {
        event: 'BWSAUregistrationSubmitted',
        eventContext: {}
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/atmmapper/registration-submitted.js
 **/